﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler';

// App imports.
//import listViewApp from './vue/listView';
import drugsOverviewApp from './vue/drugsOverview';
import storyOverviewApp from './vue/storyOverview';
import treatmentOverviewApp from './vue/treatmentOverview';
import locationWaitingtimesApp from './vue/locationWaitingtimes';
import newsOverviewApp from './vue/newsOverview';
import combinationDetailApp from './vue/combinationDetail';
import shopOverviewApp from './vue/shopOverview';
import shopDetailApp from './vue/shopDetail';
import shopCartApp from './vue/shopCart';
import eventOverviewApp from './vue/eventOverview';
import activitiesOverviewApp from './vue/activitiesOverview';
import topicOverviewApp from './vue/topicOverview';
import tipsExerciseOverviewApp from './vue/tipsExerciseOverview';

import mapsWidgetApp from './vue/mapsWidget';
import newsWidgetApp from './vue/newsWidget';
import graphWidgetApp from './vue/graphWidget';
import bmiWidgetApp from './vue/bmiWidget';
import activitiesWidgetApp from './vue/activitiesWidget';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const drugsOverviewContainer = document.getElementById('drugs-overview');
    const storyOverviewContainer = document.getElementById('story-overview');
    const treatmentOverviewContainer = document.getElementById('treatment-overview');
    const locationWaitingtimesContainer = document.getElementById('location-waitingtimes');
    const newsOverviewContainer = document.getElementById('news-overview');
    const combinationDetailContainer = document.getElementById('combination-detail');
    const shopOverviewContainer = document.getElementById('shop-overview');
    const shopDetailContainer = document.getElementById('shop-detail');
    const shopCartContainer = document.getElementById('shop-cart');
    const eventOverviewContainer = document.getElementById('event-overview');
    const activitiesOverviewContainer = document.getElementById('activities-overview');
    const topicOverviewContainer = document.getElementById('topic-overview');
    const tipsExerciseOverviewContainer = document.getElementById('tips-exercise-overview');

    const mapsWidgetContainers = document.querySelectorAll('.widget-maps');
    const newsWidgetContainers = document.querySelectorAll('.widget-news');
    const graphWidgetContainers = document.querySelectorAll('.widget-graph');
    const bmiWidgetContainers = document.querySelectorAll('.widget-bmi');
    const activitiesWidgetContainers = document.querySelectorAll('.widget-activities');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if (drugsOverviewContainer) {
        createApp(drugsOverviewApp).mount(drugsOverviewContainer);
    }

    if (storyOverviewContainer) {
        createApp(storyOverviewApp).mount(storyOverviewContainer);
    }

    if (treatmentOverviewContainer) {
        createApp(treatmentOverviewApp).mount(treatmentOverviewContainer);
    }

    if (locationWaitingtimesContainer) {
        createApp(locationWaitingtimesApp).mount(locationWaitingtimesContainer);
    }

    if (newsOverviewContainer) {
        createApp(newsOverviewApp).mount(newsOverviewContainer);
    }

    if (combinationDetailContainer) {
        createApp(combinationDetailApp).mount(combinationDetailContainer);
    }

    if (shopOverviewContainer) {
        createApp(shopOverviewApp).mount(shopOverviewContainer);
    }

    if (shopDetailContainer) {
        createApp(shopDetailApp).mount(shopDetailContainer);
    }

    if (shopCartContainer) {
        createApp(shopCartApp).mount(shopCartContainer);
    }

    if (eventOverviewContainer) {
        createApp(eventOverviewApp).mount(eventOverviewContainer);
    }

    if (activitiesOverviewContainer) {
        createApp(activitiesOverviewApp).mount(activitiesOverviewContainer);
    }

    if (topicOverviewContainer) {
        createApp(topicOverviewApp).mount(topicOverviewContainer);
    }

    if (tipsExerciseOverviewContainer) {
        createApp(tipsExerciseOverviewApp).mount(tipsExerciseOverviewContainer);
    }

	if (mapsWidgetContainers.length) {
		mapsWidgetContainers.forEach((container) => {
			createApp(mapsWidgetApp).mount(container);
		});
	}

    if (newsWidgetContainers.length) {
        newsWidgetContainers.forEach((container) => {
            createApp(newsWidgetApp).mount(container);
        });
    }

    if (graphWidgetContainers.length) {
        graphWidgetContainers.forEach((container) => {
            createApp(graphWidgetApp).mount(container);
        });
    }

    if (bmiWidgetContainers.length) {
        bmiWidgetContainers.forEach((container) => {
            createApp(bmiWidgetApp).mount(container);
        });
    }

    if (activitiesWidgetContainers.length) {
        activitiesWidgetContainers.forEach((container) => {
            createApp(activitiesWidgetApp).mount(container);
        });
    }
});
